function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1980(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.12,
    height: 14.24,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7911111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 7.12,
    fontFamily: "Arial"
  }, "\n        Manassas_Park_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.24,
    width: 23.12,
    height: 14.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.968
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 21.5,
    fontFamily: "Arial"
  }, "\n        Highland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28.76,
    width: 23.12,
    height: 15.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4454545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 36.71,
    fontFamily: "Arial"
  }, "\n        Norton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 44.66,
    width: 23.12,
    height: 20.21,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6841666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 54.765,
    fontFamily: "Arial"
  }, "\n        Craig_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 64.87,
    width: 23.12,
    height: 21.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 75.67,
    fontFamily: "Arial"
  }, "\n        Emporia_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.48,
    width: 23.12,
    height: 22.8,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0727272727272728
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 97.88000000000001,
    fontFamily: "Arial"
  }, "\n        Bath_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 109.27,
    width: 23.12,
    height: 23.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6514285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 121.1,
    fontFamily: "Arial"
  }, "\n        Lexington_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 132.93,
    width: 23.12,
    height: 23.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 144.79500000000002,
    fontFamily: "Arial"
  }, "\n        Buena_Vista_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 156.66,
    width: 23.12,
    height: 24.21,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.216842105263158
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 168.765,
    fontFamily: "Arial"
  }, "\n        Charles_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 180.87,
    width: 23.12,
    height: 24.42,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.100952380952381
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 193.08,
    fontFamily: "Arial"
  }, "\n        King_and_Queen_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 205.29,
    width: 23.12,
    height: 26.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3120000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 218.315,
    fontFamily: "Arial"
  }, "\n        Galax_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 231.34,
    width: 23.12,
    height: 26.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9266666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 244.66,
    fontFamily: "Arial"
  }, "\n        Bland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 257.97,
    width: 23.12,
    height: 26.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.216842105263158
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 271.415,
    fontFamily: "Arial"
  }, "\n        Rappahannock_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 284.86,
    width: 23.12,
    height: 27.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9266666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 298.62,
    fontFamily: "Arial"
  }, "\n        Bedford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 312.38,
    width: 23.12,
    height: 27.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7784615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 326.33,
    fontFamily: "Arial"
  }, "\n        Franklin_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 340.28,
    width: 23.12,
    height: 28.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2844444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 354.29499999999996,
    fontFamily: "Arial"
  }, "\n        Clifton_Forge_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 368.32,
    width: 23.12,
    height: 28.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5413333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 382.49,
    fontFamily: "Arial"
  }, "\n        Richmond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 396.66,
    width: 23.12,
    height: 30.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 411.70500000000004,
    fontFamily: "Arial"
  }, "\n        South_Boston_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 426.75,
    width: 23.12,
    height: 31.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7784615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 442.715,
    fontFamily: "Arial"
  }, "\n        Greene_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 458.68,
    width: 23.12,
    height: 32.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9266666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 474.7,
    fontFamily: "Arial"
  }, "\n        Surry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 490.72,
    width: 23.12,
    height: 33.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 507.49,
    fontFamily: "Arial"
  }, "\n        Williamsburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 524.26,
    width: 23.12,
    height: 33.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9266666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 541.225,
    fontFamily: "Arial"
  }, "\n        Essex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 558.19,
    width: 23.12,
    height: 34.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 575.365,
    fontFamily: "Arial"
  }, "\n        Cumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 592.54,
    width: 23.12,
    height: 34.47,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5413333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 609.775,
    fontFamily: "Arial"
  }, "\n        New_Kent_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 627.02,
    width: 23.12,
    height: 36.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5413333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 645.105,
    fontFamily: "Arial"
  }, "\n        Fluvanna_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 663.19,
    width: 23.12,
    height: 36.81,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6514285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.56,
    y: 681.595,
    fontFamily: "Arial"
  }, "\n        Covington_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 0,
    width: 26.11,
    height: 32.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0084615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.175,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Clarke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.23,
    y: 0,
    width: 26.7,
    height: 32.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4833333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.58,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        King_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.93,
    y: 0,
    width: 26.8,
    height: 32.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 89.33000000000001,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Middlesex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.73,
    y: 0,
    width: 27.24,
    height: 32.76,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0953846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.35000000000001,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Poquoson_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.97,
    y: 0,
    width: 28.22,
    height: 32.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0157142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.07999999999998,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Madison_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.19,
    y: 0,
    width: 28.86,
    height: 32.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5189473684210526
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.62,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        King_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.05,
    y: 0,
    width: 29.66,
    height: 32.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2815384615384615
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.88000000000002,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Amelia_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.71,
    y: 0,
    width: 29.78,
    height: 32.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1271428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.60000000000002,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Mathews_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246.49,
    y: 0,
    width: 30.45,
    height: 32.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6916666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.71500000000003,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Greensville_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.95,
    y: 0,
    width: 31.44,
    height: 32.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8494117647058825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292.67,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Buckingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.39,
    y: 0,
    width: 33.15,
    height: 32.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.965,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Lunenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.53,
    y: 0,
    width: 33.8,
    height: 32.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9270588235294117
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.42999999999995,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Appomattox_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.33,
    y: 0,
    width: 34.25,
    height: 32.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.455,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Sussex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.58,
    y: 0,
    width: 34.65,
    height: 32.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.905,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Floyd_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 444.22,
    y: 0,
    width: 34.7,
    height: 32.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5599999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.57000000000005,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Northumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.92,
    y: 0,
    width: 35.77,
    height: 32.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.73
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.805,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Radford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 514.69,
    y: 0,
    width: 36.03,
    height: 32.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.705,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Nelson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.72,
    y: 0,
    width: 36.52,
    height: 32.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.98,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Lancaster_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.25,
    y: 0,
    width: 36.63,
    height: 32.76,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1839999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 605.565,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Powhatan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 623.87,
    y: 0,
    width: 38.01,
    height: 32.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8199999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 642.875,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Northampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 661.88,
    y: 0,
    width: 38.12,
    height: 32.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 680.9399999999999,
    y: 16.38,
    fontFamily: "Arial"
  }, "\n        Alleghany_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 32.76,
    width: 36.68,
    height: 34.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 50.22,
    fontFamily: "Arial"
  }, "\n        Goochland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 67.68,
    width: 36.68,
    height: 35.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0658823529411765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 85.24000000000001,
    fontFamily: "Arial"
  }, "\n        Falls_Church_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 102.81,
    width: 36.68,
    height: 35.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.215625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 120.535,
    fontFamily: "Arial"
  }, "\n        Charlotte_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 138.26,
    width: 36.68,
    height: 35.45,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.726923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 155.98499999999999,
    fontFamily: "Arial"
  }, "\n        Manassas_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 173.71,
    width: 36.68,
    height: 35.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8721052631578947
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 191.495,
    fontFamily: "Arial"
  }, "\n        Fredericksburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 209.28,
    width: 36.68,
    height: 35.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 227.14,
    fontFamily: "Arial"
  }, "\n        Westmoreland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 245,
    width: 36.68,
    height: 36.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.445333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 263.45,
    fontFamily: "Arial"
  }, "\n        Caroline_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 281.9,
    width: 36.68,
    height: 40.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.834
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 301.94,
    fontFamily: "Arial"
  }, "\n        Prince_Edward_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 321.98,
    width: 36.68,
    height: 40.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.445333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 342.065,
    fontFamily: "Arial"
  }, "\n        Nottoway_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 362.15,
    width: 36.68,
    height: 40.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1576470588235295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 382.46999999999997,
    fontFamily: "Arial"
  }, "\n        Rockbridge_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 402.79,
    width: 36.68,
    height: 40.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8215384615384616
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 423.21500000000003,
    fontFamily: "Arial"
  }, "\n        Louisa_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 443.64,
    width: 36.68,
    height: 41.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1576470588235295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 464.39,
    fontFamily: "Arial"
  }, "\n        Harrisonburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 485.14,
    width: 36.68,
    height: 41.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 506.13,
    fontFamily: "Arial"
  }, "\n        Brunswick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 527.12,
    width: 36.68,
    height: 42.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.834
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 548.195,
    fontFamily: "Arial"
  }, "\n        Prince_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 569.28,
    width: 36.68,
    height: 42.8,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.445333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 590.68,
    fontFamily: "Arial"
  }, "\n        Waynesboro_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 612.08,
    width: 36.68,
    height: 43.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.62
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 634,
    fontFamily: "Arial"
  }, "\n        Patrick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.12,
    y: 655.91,
    width: 36.68,
    height: 44.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8215384615384616
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 41.46,
    y: 677.9549999999999,
    fontFamily: "Arial"
  }, "\n        Orange_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 32.76,
    width: 38.98,
    height: 43.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.248333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.28,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Bristol_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.77,
    y: 32.76,
    width: 39.17,
    height: 43.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.797857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.35499999999999,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Grayson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.94,
    y: 32.76,
    width: 39.41,
    height: 43.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1894444444444443
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.64499999999998,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Southampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.35,
    y: 32.76,
    width: 39.62,
    height: 43.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6413333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.16,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Winchester_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.98,
    y: 32.76,
    width: 41.4,
    height: 43.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1846153846153844
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.67999999999998,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Warren_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.38,
    y: 32.76,
    width: 41.52,
    height: 43.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4600000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.14,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Giles_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.9,
    y: 32.76,
    width: 41.59,
    height: 43.89,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9804761904761907
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.695,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Colonial_Heights_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.49,
    y: 32.76,
    width: 41.99,
    height: 43.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.624375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.485,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Dinwiddie_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.48,
    y: 32.76,
    width: 42.07,
    height: 43.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.474705882352941
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.51500000000004,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Martinsville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.55,
    y: 32.76,
    width: 42.71,
    height: 43.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.882727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.90500000000003,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Page_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 32.76,
    width: 43.41,
    height: 43.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8939999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.955,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Culpeper_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.66,
    y: 32.76,
    width: 46.57,
    height: 43.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 534.945,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Isle_of_Wight_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 558.23,
    y: 32.76,
    width: 47.1,
    height: 43.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.376153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 581.78,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Hopewell_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 605.33,
    y: 32.76,
    width: 47.25,
    height: 43.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.581764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.955,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Gloucester_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 652.57,
    y: 32.76,
    width: 47.43,
    height: 43.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.376153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.2850000000001,
    y: 54.705,
    fontFamily: "Arial"
  }, "\n        Staunton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 76.66,
    width: 49.2,
    height: 42.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.666875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 97.995,
    fontFamily: "Arial"
  }, "\n        Dickenson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 119.33,
    width: 49.2,
    height: 42.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 140.69,
    fontFamily: "Arial"
  }, "\n        Fairfax_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 162.04,
    width: 49.2,
    height: 42.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5264705882352945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 183.515,
    fontFamily: "Arial"
  }, "\n        James_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 205,
    width: 49.2,
    height: 45.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.869375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 227.95499999999998,
    fontFamily: "Arial"
  }, "\n        Botetourt_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 250.9,
    width: 49.2,
    height: 46.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8983333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 274.29,
    fontFamily: "Arial"
  }, "\n        Wythe_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 297.69,
    width: 49.2,
    height: 47.18,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 321.28,
    fontFamily: "Arial"
  }, "\n        Amherst_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 344.87,
    width: 49.2,
    height: 47.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.642777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 368.65500000000003,
    fontFamily: "Arial"
  }, "\n        Mecklenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 392.44,
    width: 49.2,
    height: 50.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 417.465,
    fontFamily: "Arial"
  }, "\n        Lee_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 442.48,
    width: 49.2,
    height: 50.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 467.53000000000003,
    fontFamily: "Arial"
  }, "\n        Scott_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 492.58,
    width: 49.2,
    height: 50.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 517.635,
    fontFamily: "Arial"
  }, "\n        Salem_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 542.69,
    width: 49.2,
    height: 51.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5142857142857147
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 568.4000000000001,
    fontFamily: "Arial"
  }, "\n        Carroll_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 594.11,
    width: 49.2,
    height: 52.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5142857142857147
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 620.36,
    fontFamily: "Arial"
  }, "\n        Halifax_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.79,
    y: 646.6,
    width: 49.2,
    height: 53.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5894736842105264
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.39,
    y: 673.3000000000001,
    fontFamily: "Arial"
  }, "\n        Spotsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 76.66,
    width: 50.41,
    height: 55.37,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3606666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.20499999999998,
    y: 104.345,
    fontFamily: "Arial"
  }, "\n        Buchanan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.4,
    y: 76.66,
    width: 50.74,
    height: 55.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3826666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.77,
    y: 104.345,
    fontFamily: "Arial"
  }, "\n        Accomack_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.14,
    y: 76.66,
    width: 51.16,
    height: 55.37,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.71999999999997,
    y: 104.345,
    fontFamily: "Arial"
  }, "\n        Frederick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.3,
    y: 76.66,
    width: 51.57,
    height: 55.37,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6835714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.08500000000004,
    y: 104.345,
    fontFamily: "Arial"
  }, "\n        Russell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.87,
    y: 76.66,
    width: 52.59,
    height: 55.37,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5060000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.165,
    y: 104.345,
    fontFamily: "Arial"
  }, "\n        Franklin_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.46,
    y: 76.66,
    width: 53.13,
    height: 55.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.125294117647059
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.025,
    y: 104.345,
    fontFamily: "Arial"
  }, "\n        Shenandoah_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418.59,
    y: 76.66,
    width: 54.64,
    height: 55.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6426666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.90999999999997,
    y: 104.345,
    fontFamily: "Arial"
  }, "\n        Fauquier_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.23,
    y: 76.66,
    width: 56.15,
    height: 55.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9549999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 501.305,
    y: 104.345,
    fontFamily: "Arial"
  }, "\n        Bedford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.38,
    y: 76.66,
    width: 56.25,
    height: 55.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.614166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 557.505,
    y: 104.345,
    fontFamily: "Arial"
  }, "\n        Smyth_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 585.63,
    y: 76.66,
    width: 57.1,
    height: 55.37,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9549999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.18,
    y: 104.345,
    fontFamily: "Arial"
  }, "\n        Pulaski_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.73,
    y: 76.66,
    width: 57.27,
    height: 55.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.691333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.365,
    y: 104.345,
    fontFamily: "Arial"
  }, "\n        Stafford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 132.02,
    width: 60.74,
    height: 52.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7690909090909095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.37,
    y: 158.25,
    fontFamily: "Arial"
  }, "\n        York_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 184.48,
    width: 60.74,
    height: 56.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.164545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.37,
    y: 212.885,
    fontFamily: "Arial"
  }, "\n        Wise_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 241.3,
    width: 60.74,
    height: 57.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8266666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.37,
    y: 270,
    fontFamily: "Arial"
  }, "\n        Petersburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 298.7,
    width: 60.74,
    height: 61.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.037
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.37,
    y: 329.375,
    fontFamily: "Arial"
  }, "\n        Charlottesville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 360.05,
    width: 60.74,
    height: 62.37,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.049333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.37,
    y: 391.235,
    fontFamily: "Arial"
  }, "\n        Tazewell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 422.42,
    width: 60.74,
    height: 63.65,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.049333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.37,
    y: 454.245,
    fontFamily: "Arial"
  }, "\n        Campbell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 486.07,
    width: 60.74,
    height: 67.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5729411764705885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.37,
    y: 519.785,
    fontFamily: "Arial"
  }, "\n        Washington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 553.5,
    width: 60.74,
    height: 72.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0616666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.37,
    y: 589.74,
    fontFamily: "Arial"
  }, "\n        Suffolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 625.98,
    width: 60.74,
    height: 74.02,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.338571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.37,
    y: 662.99,
    fontFamily: "Arial"
  }, "\n        Augusta_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.73,
    y: 132.02,
    width: 60.88,
    height: 74.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5811764705882356
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.17,
    y: 169.425,
    fontFamily: "Arial"
  }, "\n        Montgomery_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.61,
    y: 132.02,
    width: 60.94,
    height: 74.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.687692307692307
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.08000000000004,
    y: 169.425,
    fontFamily: "Arial"
  }, "\n        Danville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.55,
    y: 132.02,
    width: 62.42,
    height: 74.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.201666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.76,
    y: 169.425,
    fontFamily: "Arial"
  }, "\n        Henry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.97,
    y: 132.02,
    width: 62.69,
    height: 74.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6876470588235293
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.31500000000005,
    y: 169.425,
    fontFamily: "Arial"
  }, "\n        Rockingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.66,
    y: 132.02,
    width: 68.73,
    height: 74.81,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.295625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.02500000000003,
    y: 169.425,
    fontFamily: "Arial"
  }, "\n        Albemarle_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.39,
    y: 132.02,
    width: 71.18,
    height: 74.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7463157894736847
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.98,
    y: 169.425,
    fontFamily: "Arial"
  }, "\n        Pittsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.58,
    y: 132.02,
    width: 71.49,
    height: 74.81,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.106428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 592.325,
    y: 169.425,
    fontFamily: "Arial"
  }, "\n        Hanover_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 628.07,
    y: 132.02,
    width: 71.93,
    height: 74.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.137857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 664.0350000000001,
    y: 169.425,
    fontFamily: "Arial"
  }, "\n        Loudoun_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.73,
    y: 206.83,
    width: 86.67,
    height: 73.98,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.284285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.065,
    y: 243.82000000000002,
    fontFamily: "Arial"
  }, "\n        Lynchburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.73,
    y: 280.81,
    width: 86.67,
    height: 93.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.190714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.065,
    y: 327.49,
    fontFamily: "Arial"
  }, "\n        Roanoke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.73,
    y: 374.18,
    width: 86.67,
    height: 105.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.065,
    y: 427.12,
    fontFamily: "Arial"
  }, "\n        Roanoke_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.73,
    y: 480.06,
    width: 86.67,
    height: 108.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7780000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.065,
    y: 534.52,
    fontFamily: "Arial"
  }, "\n        Portsmouth_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.73,
    y: 588.97,
    width: 86.67,
    height: 111.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7780000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 213.065,
    y: 644.485,
    fontFamily: "Arial"
  }, "\n        Chesapeake_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 206.83,
    width: 101.99,
    height: 97.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.102500000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.395,
    y: 255.44500000000002,
    fontFamily: "Arial"
  }, "\n        Hampton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.39,
    y: 206.83,
    width: 105.65,
    height: 97.23,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 411.215,
    y: 255.44500000000002,
    fontFamily: "Arial"
  }, "\n        Prince_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.04,
    y: 206.83,
    width: 109.08,
    height: 97.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.482
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.58,
    y: 255.44500000000002,
    fontFamily: "Arial"
  }, "\n        Alexandria_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 573.12,
    y: 206.83,
    width: 126.88,
    height: 97.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.719411764705883
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.56,
    y: 255.44500000000002,
    fontFamily: "Arial"
  }, "\n        Newport_News_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 304.07,
    width: 124.2,
    height: 112.49,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.920526315789473
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.5,
    y: 360.315,
    fontFamily: "Arial"
  }, "\n        Chesterfield_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 416.56,
    width: 124.2,
    height: 141.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.7625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.5,
    y: 487.24,
    fontFamily: "Arial"
  }, "\n        Arlington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 557.92,
    width: 124.2,
    height: 142.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.5,
    y: 628.9599999999999,
    fontFamily: "Arial"
  }, "\n        Norfolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.6,
    y: 304.07,
    width: 155.9,
    height: 127.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.089285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.55,
    y: 367.695,
    fontFamily: "Arial"
  }, "\n        Henrico_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.5,
    y: 304.07,
    width: 163.5,
    height: 127.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.697368421052632
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.25,
    y: 367.695,
    fontFamily: "Arial"
  }, "\n        Virginia_Beach_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.6,
    y: 431.32,
    width: 85.13,
    height: 268.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.548461538461538
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 423.165,
    y: 565.66,
    fontFamily: "Arial"
  }, "\n        Richmond_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 465.73,
    y: 431.32,
    width: 234.27,
    height: 268.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.73357142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 582.865,
    y: 565.66,
    fontFamily: "Arial"
  }, "\n        Fairfax_County\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1980);
export default __webpack_public_path__ + "static/media/1980.2981991e21eab2fcaa6f1322576f9224.svg";
export { ForwardRef as ReactComponent };